import React from 'react';
import styled from 'styled-components';
import { BUTTON_THEME_EMPTY_GREEN, BUTTON_THEME_FULL_GREEN, ButtonThemesStyles } from './Button/themes';

export const SEGMENTED_BUTTON_THEME_GREEN = 'SEGMENTED_BUTTON_THEME_GREEN';

const SegmentedButtonThemes = {
    SEGMENTED_BUTTON_THEME_GREEN: {
        full: BUTTON_THEME_FULL_GREEN,
        empty: BUTTON_THEME_EMPTY_GREEN
    }
};

const StSegmentedButton = styled.div`
    border-color: ${props => props.theme.border};
    border-width: ${props => (props.theme.border ? '1px' : '0')};
    font-size: ${props => `${props.theme.fontSize}px`};
    justify-content: center;
    border-style: solid;
    display: inline-flex;
    border-radius: 2px;
    align-items: center;
    line-height: 1;
    box-sizing: border-box;
    user-select: none;
    cursor: pointer !important;
`;

const StSegmentedButtonOption = styled.div`
    color: ${props => props.theme.text} !important;
    background-color: ${props => props.theme.background};
    padding: 0 1em;
    line-height: 2em;
    text-align: center;
`;

export enum BUTTON_SIZE_TYPES {
    BUTTON_SIZE_SMALL = 'small',
    BUTTON_SIZE_MEDIUM = 'medium',
    BUTTON_SIZE_LARGE = 'large'
}

interface Props {
    className?: string;
    onClick?: () => void;
    size?: BUTTON_SIZE_TYPES;
    options: Options[];
}

type Options = {
    label: string;
    active: boolean;
};

export const SegmentedButton = (props: Props) => {
    const buttonThemeActive = {
        ...ButtonThemesStyles[SegmentedButtonThemes.SEGMENTED_BUTTON_THEME_GREEN.empty]
    };

    const buttonThemeInActive = {
        ...ButtonThemesStyles[SegmentedButtonThemes.SEGMENTED_BUTTON_THEME_GREEN.full]
    };

    switch (props.size) {
        case BUTTON_SIZE_TYPES.BUTTON_SIZE_SMALL:
            buttonThemeActive.fontSize = 11;
            break;
        case BUTTON_SIZE_TYPES.BUTTON_SIZE_MEDIUM:
            buttonThemeActive.fontSize = 13;
            break;
        case BUTTON_SIZE_TYPES.BUTTON_SIZE_LARGE:
            buttonThemeActive.fontSize = 14;
            break;
        default:
            break;
    }

    return (
        <StSegmentedButton theme={buttonThemeActive} onClick={props.onClick} className={props.className}>
            {props.options.map((option, index) => (
                <StSegmentedButtonOption
                    key={`segemented-button-option-${index}`}
                    theme={option.active ? buttonThemeActive : buttonThemeInActive}
                >
                    {option.label}
                </StSegmentedButtonOption>
            ))}
        </StSegmentedButton>
    );
};
